import { useMemo } from 'react';
import { sortBy } from 'lodash-es';
import { SchedulerDayColumn } from '@lp/features/Scheduler/types';
import { getShiftSiblingsMap } from '@lp/features/Scheduler/utils';
import { getOMSSiblingData, OMSOnCallResource } from '@lp/features/Scheduler/SchedulerOMS';
import { OMSResourcesWithShifts, OMSShift, OMSShiftType } from '@/api/apis/resources/schedule';

export const useOMSGridShiftSiblingsMap = (dayCols: SchedulerDayColumn[], myShifts?: Record<string, OMSShift>) => {
  return useMemo(() => getShiftSiblingsMap(dayCols, myShifts, getOMSSiblingData), [dayCols, myShifts]);
};

export const useOMSOnCallResourcesMap = (
  dayCols: SchedulerDayColumn[],
  shiftsData: OMSResourcesWithShifts,
  resourceIds?: string[],
) => {
  return useMemo(() => {
    const onCallResourcesMap: Record<string, OMSOnCallResource[]> = {};

    dayCols.forEach((column) => {
      const onCallResources = Object.values(shiftsData).reduce((acc, segment) => {
        const dayShift = segment.days[column.key];
        const hasId = !resourceIds?.length || resourceIds.includes(segment.resource.id);
        const isValidUser = hasId && !!segment.resource;

        if (isValidUser && dayShift?.slot1?.shiftType === OMSShiftType.OnCall) {
          acc.push({ ...segment.resource, slotIndex: 1, isVoluntary: dayShift.slot1.isVoluntary });
        }
        if (isValidUser && dayShift?.slot2?.shiftType === OMSShiftType.OnCall) {
          acc.push({ ...segment.resource, slotIndex: 2, isVoluntary: dayShift.slot2.isVoluntary });
        }
        return acc;
      }, [] as OMSOnCallResource[]);

      onCallResourcesMap[column.key] = sortBy(onCallResources, ['slotIndex', 'firstName']);
    });

    return onCallResourcesMap;
  }, [dayCols, resourceIds, shiftsData]);
};
